import React, { useMemo } from "react";
import { useStore } from "../stores/store";
import { DraggableKeys } from "../interfaces/config";

export const ScaleSettings = () => {
  const { scaleType, activateTool, scale } = useStore();

  const scaleFt = useMemo(() => Math.round((scale / 12) * 10) / 10, [scale]);

  return scaleType === "scale" && (
    <div className="flex items-center text-xs mt-1">
      <span className="mr-1">Scale:</span>
      <span>1" = {scaleFt}'</span>
      <button
        onClick={() => activateTool(DraggableKeys.SCALE_SETTINGS_DRAGGABLE)}
        className="btn-athena btn-xs ml-2"
      >
        Set Scale
      </button>
    </div>
  );
};
